import { defineStore, acceptHMRUpdate } from 'pinia'

export const appConfigurationStore = defineStore('appConfigurationStore', {
  state: () => {
    return {
      appConfiguration: {}
    }
  },
  actions: {
    setAppConfiguration(config) {
      this.appConfiguration = config
    }
  },
  getters: {
    getAppDisplayFront(state) {
      return state.appConfiguration.displayFront
    }
  },
  persist: {
    paths: ['appConfiguration']
  }
})

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(appConfigurationStore, import.meta.hot))
}
